// Public Core calls without a member session (invitations): no Authorization, no cookies, no referrer, no HTTP cache;
// the token stays in the JSON body. Nothing is logged; failures only return a status.
import { API } from "./api";
import { ENV, coreState, LOCAL_PROFILE } from "./environment";
import { isTestAddress } from "./memberDerive";

let transport = (url, init) => fetch(url, init);
export const setPublicTransport = (fn) => { transport = fn; };

// Local stack: nothing before a verified isolation answer, and only fictitious test addresses.
const localBlocked = (path, body) => LOCAL_PROFILE && (Boolean(coreState.problem) || (path.endsWith("/redeem") && !isTestAddress(body?.email)));

export async function publicPost(path, body) {
  if (ENV.problems.length || !/^\/member\/invitations\/(check|redeem)$/.test(path) || localBlocked(path, body)) return { status: null, data: null, blocked: true };
  try {
    const res = await transport(`${API}${path}`, {
      method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body),
      credentials: "omit", cache: "no-store", referrerPolicy: "no-referrer", redirect: "error", mode: "cors",
    });
    let data = null;
    if ((res.headers.get("content-type") || "").toLowerCase().includes("application/json")) {
      try { data = await res.json(); } catch (_) { data = null; }
    }
    return { status: res.status, data };
  } catch (_) {
    return { status: null, data: null };
  }
}
